import { generateNumbers } from "utils/generateNumbers";
import {Container, Item, Items, Picker} from "../styles";
import { Row } from "components/styles";
import CustomButton from "components/CustomButton/CustomButton";
import { CUSTOM_BUTTON_PROPS } from "views/components/AttendanceList/TakeTeacherAttendancePanel/constants";
import { useEffect, useRef, useState } from "react";


const SelectTime = ({
    show,
    setOpen,
    value,
    setTime
}) => {
    const hourRef = useRef(null);
    const minuteRef = useRef(null);
    const [hour, setHour] = useState('00');
    const [minute, setMinute] = useState('00');
    const hours = generateNumbers(24);
    const minutes = generateNumbers(60);

    useEffect(() => {
        if(value){
            const [h, m] = value.split(":");
            setHour(h);
            setMinute(m);
        }
    }, [value]);

    const scrollToValue = (ref, list, value) => {
        if (!ref.current) return;

        const index = list.indexOf(value);
        const ITEM_HEIGHT = 30;

        ref.current.scrollTop = index * ITEM_HEIGHT;
    };
    useEffect(() => {
        if (show) {
            scrollToValue(hourRef, hours, hour);
            scrollToValue(minuteRef, minutes, minute);
        }
    }, [show]);

    

    const handleSelectHour = (h) => {
        setHour(h);
        setTime(`${h}:${minute}:00`);
    }
    const handleSelectMinute = (m) => {
        setMinute(m);
        setTime(`${hour}:${m}:00`);
    }
    const handleCloseOptions = () => {
        setOpen(false)
    }

    return(
        <>
            {show &&
                <Container>
                    <Picker>
                        <Items ref={hourRef}>
                            {hours.map((h) => (
                                <Item
                                    key={h}
                                    active={h === hour}
                                    onClick={() => handleSelectHour(h)}
                                >
                                    {h}
                                </Item>
                            ))}
                        </Items>
                        <Items ref={minuteRef}>
                            {minutes.map((m) => (
                                <Item
                                    key={m}
                                    active={m === minute}
                                    onClick={() => handleSelectMinute(m)}
                                >
                                    {m}
                                </Item>
                            ))}
                        </Items>
                    </Picker>
                    <Row>
                        <CustomButton
                            {...CUSTOM_BUTTON_PROPS}
                            text="OK"
                            variant="secondary"
                            onClick={handleCloseOptions}
                        />
                    </Row>
                </Container>
            }
        </>
    )
}

export default SelectTime;